import React from 'react';
import NewsUpdates from './NewsUpdates';
import '../css/Home.css';

const Home04 = () => {
    const heading = 'NEWS AND UPDATES';

    return (
        <div className='home04-container flex-center'>
            <div className='home03-headline-container'>
                <div className='home01-tagline palanquin-dark bold primary-yellow-text'>{heading}</div>
            </div>
            <NewsUpdates/>  
        </div>
    );
};

export default Home04;